module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_49.f25fa0dc.jpg";